// extracted by mini-css-extract-plugin
export default {"tool-icon":"tool_tool-icon__RHBqx","minHeight":"tool_minHeight__Ell1t"};